export default "__VITE_ASSET__DIco1cNO__"